import { StyleSheet } from 'react-native';

// ============================================================
// Shared Chart Styles
// ============================================================

export const chartStyles = StyleSheet.create({
  // Container styles
  container: {
    borderRadius: 12,
    padding: 16,
    marginVertical: 8,
  },
  title: {
    fontSize: 16,
    fontWeight: '600',
    textAlign: 'right',
    marginBottom: 16,
  },

  // Legend styles
  legendContainer: {
    flexDirection: 'row-reverse',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: 12,
    marginTop: 16,
    paddingTop: 12,
    borderTopWidth: 1,
  },
  legendItem: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
    gap: 6,
  },
  legendDot: {
    width: 10,
    height: 10,
    borderRadius: 5,
  },
  legendSquare: {
    width: 10,
    height: 10,
    borderRadius: 2,
  },
  legendLine: {
    width: 16,
    height: 3,
    borderRadius: 2,
  },
  legendLineDashed: {
    width: 16,
    height: 0,
    borderWidth: 1.5,
    borderStyle: 'dashed',
  },
  legendText: {
    fontSize: 11,
  },
  legendValue: {
    fontSize: 11,
    fontWeight: '600',
  },

  // Tooltip styles
  tooltip: {
    borderRadius: 8,
    padding: 12,
  },

  // Empty state styles
  emptyState: {
    height: 200,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    borderRadius: 12,
  },
  emptyStateIcon: {
    marginBottom: 8,
  },
  emptyStateTitle: {
    fontSize: 16,
    fontWeight: '600',
    textAlign: 'center',
  },
  emptyStateText: {
    fontSize: 14,
    textAlign: 'center',
  },

  // Chart wrapper styles
  chartWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  chartScrollContent: {
    flexGrow: 1,
    alignItems: 'center',
  },
});

// ============================================================
// Chart Color Palettes
// ============================================================

export const CHART_COLORS = {
  // Primary colors for charts
  primary: '#A9211F',
  secondary: '#3B82F6',
  tertiary: '#22C55E',
  quaternary: '#F97316',
  quinary: '#A855F7',
  senary: '#EC4899',

  // Status colors
  success: '#22C55E',
  warning: '#EAB308',
  danger: '#EF4444',
  info: '#3B82F6',

  // Achievement colors
  excellent: '#22C55E',
  good: '#84CC16',
  acceptable: '#EAB308',
  poor: '#EF4444',

  // Radar chart colors
  radar: {
    goals: '#22C55E',
    initiatives: '#F97316',
    processes: '#EF4444',
    services: '#A855F7',
    unitGoals: '#3B82F6',
    humanCapital: '#EC4899',
  },

  // Gauge colors
  gauge: {
    track: '#E5E7EB',
    trackDark: '#374151',
    actual: '#2CA02C',
    target: '#BBF7D0',
  },
};

// ============================================================
// Chart Threshold Helpers
// ============================================================

export const getStatusColor = (percentage: number): string => {
  if (percentage >= 100) return CHART_COLORS.excellent;
  if (percentage >= 80) return CHART_COLORS.good;
  if (percentage >= 60) return CHART_COLORS.acceptable;
  return CHART_COLORS.poor;
};

export const getAchievementStatus = (percentage: number): 'excellent' | 'good' | 'acceptable' | 'poor' => {
  if (percentage >= 100) return 'excellent';
  if (percentage >= 80) return 'good';
  if (percentage >= 60) return 'acceptable';
  return 'poor';
};

export const getStatusLabel = (status: 'excellent' | 'good' | 'acceptable' | 'poor'): string => {
  const labels = {
    excellent: 'ممتاز',
    good: 'جيد',
    acceptable: 'مقبول',
    poor: 'ضعيف',
  };
  return labels[status];
};
